<template>
  <div class="validations-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div class="validations-container">
      <div class="validations-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-back-modern" @click="$router.go(-1)">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-clipboard-check title-icon"></i>
              Minhas Validações Técnicas
            </h1>
            <p class="page-subtitle">
              Visualize o histórico das suas validações realizadas
            </p>
          </div>

          <div class="actions-section">
            <v-btn
              class="btn-refresh-modern"
              @click="handleRefresh"
              :disabled="loading"
            >
              <i :class="['fas mr-2', 'fa-sync-alt']"></i>
              {{ loading ? "Atualizando..." : "Atualizar" }}
            </v-btn>
          </div>
        </div>
      </div>

      <div class="validations-content">
        <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
          <div class="validation-section mb-2">
            <div class="section-header">
              <div class="section-title">
                <i class="fas fa-notes-medical section-icon"></i>
                <h2>Evoluções</h2>
              </div>
              <div class="section-badge">
                <span class="badge-count">{{ evolutions.length }}</span>
                <span class="badge-label">Validados</span>
              </div>
            </div>
            <div class="section-content">
              <Evolution
                :data="evolutions"
                :tableOptions="optionsEvolution"
                :total="totalEvolution"
                @paginate="handlePaginateEvolution"
              />
            </div>
          </div>

          <div class="validation-section mb-2">
            <div class="section-header">
              <div class="section-title">
                <i class="fas fa-capsules section-icon"></i>
                <h2>Prescrições</h2>
              </div>
              <div class="section-badge">
                <span class="badge-count">{{ prescriptions.length }}</span>
                <span class="badge-label">Validados</span>
              </div>
            </div>
            <div class="section-content">
              <Prescription
                :data="prescriptions"
                :tableOptions="optionsPrescription"
                :total="totalPrescription"
                @paginate="handlePaginatePrescription"
              />
            </div>
          </div>

          <div class="validation-section mb-2">
            <div class="section-header">
              <div class="section-title">
                <i class="fas fa-stethoscope section-icon"></i>
                <h2>Semiologia</h2>
              </div>
              <div class="section-badge">
                <span class="badge-count">{{ semiologys.length }}</span>
                <span class="badge-label">Validados</span>
              </div>
            </div>
            <div class="section-content">
              <Semiology
                :data="semiologys"
                :tableOptions="optionsSemiology"
                :total="totalSemiology"
                @paginate="handlePaginateSemiology"
              />
            </div>
          </div>
        </b-overlay>

        <div v-if="errors.length > 0" class="errors-section">
          <ErrorsMessages :errors="errors" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import Evolution from "../templates/TechnicalResponsibleMyValidations/Evolution";
import Prescription from "../templates/TechnicalResponsibleMyValidations/Prescription";
import Semiology from "../templates/TechnicalResponsibleMyValidations/Semiology";

import api from "../services/api";

import permission from "../lib/permission";

import { formatDate } from "../lib/format";

export default {
  name: "TechnicalResponsibleMyValidations",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    Evolution,
    Prescription,
    Semiology,
  },

  data() {
    return {
      totalEvolution: 0,
      optionsEvolution: {},

      totalPrescription: 0,
      optionsPrescription: {},

      totalSemiology: 0,
      optionsSemiology: {},

      evolutions: [],
      prescriptions: [],
      semiologys: [],

      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    formatDate,

    handlePaginateEvolution({ page, itemsPerPage }) {
      this.getEvolutions(page, itemsPerPage);
    },

    handlePaginatePrescription({ page, itemsPerPage }) {
      this.getPrescriptions(page, itemsPerPage);
    },

    handlePaginateSemiology({ page, itemsPerPage }) {
      this.getSemiologys(page, itemsPerPage);
    },

    async handleRefresh() {
      await this.retrieve();
    },

    async retrieve() {
      this.errors = []; // Limpa erros anteriores
      await this.getEvolutions();
      await this.getPrescriptions();
      await this.getSemiologys();
    },

    async getEvolutions(page = 1, itemsPerPage = 10) {
      try {
        this.loading = true;

        let params = { type: "EVOLUTION", page, itemsPerPage };

        const response = await api.get(
          "/rest-home/technical-responsible-my-validations/paginate",
          {
            params,
          }
        );

        const { evolutions, total } = response.data;

        this.evolutions = evolutions;
        this.totalEvolution = total;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async getPrescriptions(page = 1, itemsPerPage = 10) {
      try {
        this.loading = true;

        let params = { type: "PRESCRIPTION", page, itemsPerPage };

        const response = await api.get(
          "/rest-home/technical-responsible-my-validations/paginate",
          {
            params,
          }
        );

        const { prescriptions, total } = response.data;

        this.prescriptions = prescriptions;
        this.totalPrescription = total;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async getSemiologys(page = 1, itemsPerPage = 10) {
      try {
        this.loading = true;

        let params = { type: "SEMIOLOGY", page, itemsPerPage };

        const response = await api.get(
          "/rest-home/technical-responsible-my-validations/paginate",
          {
            params,
          }
        );

        const { semiologys, total } = response.data;

        this.semiologys = semiologys;
        this.totalSemiology = total;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.validations-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.validations-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.validations-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

/* Buttons */
.btn-back-modern {
  background: transparent !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 12px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.btn-back-modern:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.btn-refresh-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-refresh-modern:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

.btn-refresh-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Content Section */
.validations-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 32px;
}

.loading-overlay {
  border-radius: 16px;
}

/* Validation Sections */
.validation-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  transition: all 0.3s ease;
}

.validation-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

/* Section Headers */
.section-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-title h2 {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.section-icon {
  color: #0f65b0;
  font-size: 18px;
}

/* Section Badges */
.section-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(16, 185, 129, 0.1);
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.badge-count {
  font-size: 18px;
  font-weight: 700;
  color: #059669;
}

.badge-label {
  font-size: 12px;
  font-weight: 600;
  color: #059669;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Section Content */
.section-content {
  padding: 24px;
}

/* Error Section */
.errors-section {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fca5a5;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.1);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .page-title {
    justify-content: center;
  }

  .actions-section {
    display: flex;
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .validations-container {
    padding: 0 16px;
  }

  .validations-header {
    padding: 20px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .validations-content {
    gap: 20px;
  }

  .section-header {
    padding: 20px;
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }

  .section-title {
    justify-content: center;
  }

  .section-badge {
    justify-content: center;
  }

  .section-content {
    padding: 20px;
  }

  .errors-section {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .btn-back-modern,
  .btn-refresh-modern {
    padding: 10px 16px !important;
    font-size: 14px !important;
  }

  .page-title {
    font-size: 20px;
    flex-direction: column;
    gap: 8px;
  }

  .title-icon {
    font-size: 24px;
  }

  .section-title h2 {
    font-size: 18px;
  }

  .section-icon {
    font-size: 16px;
  }

  .badge-count {
    font-size: 16px;
  }

  .section-content {
    padding: 16px;
  }

  .errors-section {
    padding: 16px;
  }
}

/* Loading States */
.loading-overlay >>> .b-overlay-backdrop {
  background: rgba(248, 250, 252, 0.95);
  backdrop-filter: blur(4px);
}

/* Custom Animation */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.validation-section {
  animation: slideInUp 0.5s ease-out;
}

.validation-section:nth-child(1) {
  animation-delay: 0.1s;
}

.validation-section:nth-child(2) {
  animation-delay: 0.2s;
}

.validation-section:nth-child(3) {
  animation-delay: 0.3s;
}

/* Focus States for Accessibility */
.btn-back-modern:focus,
.btn-refresh-modern:focus {
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.3) !important;
}

/* Spinning Animation for Loading Icon */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.fa-spin {
  animation: spin 1s linear infinite;
}
</style>